module.exports = __webpack_public_path__ + "images/category_lp/hobby/store_images/4@2x_b17688a65189506b02a457d82eb94c0f.png";